import InfiniteScroll from 'react-infinite-scroll-component'
import { EmptyFunction } from '../utils/functions'

export const Pagination = ({
  listLength = [],
  next = EmptyFunction,
  hasMore = true,
  children,
  loader = <h4>Loading...</h4>,
  className,
  ...rest
}) => {
  return (
    <InfiniteScroll {...{ dataLength: listLength, next, hasMore, loader, className, ...rest }}>
      {children}
    </InfiniteScroll>
  )
}
